const Style = {
    form: 'space-y-6',
    stepBlock: 'space-y-5',
    lockedNote: 'text-sm text-text-secondary',
    grid2: 'grid gap-4 sm:grid-cols-2',
    // Step 2 — subject/description beside priority, with the dropzone spanning
    // the full width underneath. Priority alone is much shorter than the text
    // fields, so keeping attachments in the left column left a dead gap under
    // the priority cards.
    step2Grid: 'grid gap-5 md:grid-cols-2 md:items-start',
    step2Col: 'space-y-4',
    field: 'space-y-1.5',
    labelRow: 'flex items-baseline justify-between gap-2',
    label: 'text-sm font-medium text-text-primary',
    optional: 'text-xs font-normal text-text-muted',
    input: `flex h-10 w-full rounded-md border border-input bg-surface px-3 py-2 text-sm text-text-primary
        shadow-sm transition-colors placeholder:text-text-muted focus-visible:outline-none
        focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50`,
    textarea: `min-h-[5.5rem] w-full rounded-md border border-input bg-surface px-3 py-2 text-sm text-text-primary
        shadow-sm transition-colors placeholder:text-text-muted focus-visible:outline-none
        focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50`,
    select: `flex h-10 w-full rounded-md border border-input bg-surface px-3 py-2 text-sm text-text-primary
        shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
        disabled:cursor-not-allowed disabled:opacity-50`,
    // Invalid fields need more than the red message below them — the border is
    // what you notice when scanning back up a form you just failed to submit.
    inputInvalid: 'border-error focus-visible:ring-error',
    error: 'flex items-start gap-1.5 text-xs text-error',
    errorIcon: 'mt-px shrink-0',
    hint: 'text-xs leading-relaxed text-text-muted',
    actions: 'flex flex-wrap gap-3 pt-2',

    priorityList: 'grid grid-cols-1 gap-2 sm:grid-cols-2',
    priorityLabel: 'relative block cursor-pointer',
    // `ring-inset` rather than an offset ring: the offset colour would have to
    // match whatever sits behind the card, and this form renders both on the
    // public page and inside an in-app modal.
    priorityCard: `relative flex gap-2.5 rounded-lg border p-2.5 pr-7 text-left transition-all
        peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-focus-visible:ring-offset-1`,
    priorityCardSelected: 'ring-2 ring-inset',
    priorityCheck: 'absolute right-2 top-2.5',
    priorityDot: 'mt-1 h-2 w-2 shrink-0 rounded-full',
    priorityTitle: 'block text-sm font-semibold leading-tight',
    priorityHelp: 'mt-0.5 block text-[11px] leading-snug text-text-secondary',
    priorityGuidance: 'text-xs leading-relaxed text-text-muted',

    dropzone: `flex min-h-[5.5rem] cursor-pointer flex-col items-center justify-center gap-1.5 rounded-lg
        border border-dashed border-border bg-muted/30 px-3 py-5 text-center transition-colors
        hover:border-primary-300 hover:bg-muted/50
        peer-focus-visible:border-primary-600 peer-focus-visible:ring-2 peer-focus-visible:ring-ring`,
    dropzoneActive: 'border-primary-600 bg-primary-50/60 dark:bg-primary-900/20',
    dropzoneIcon: 'text-text-muted',
    dropzoneText: 'text-sm font-medium text-text-primary',
    dropzoneHint: 'text-xs text-text-muted',
    fileListLabel: 'text-xs font-medium text-text-secondary',
    fileList: 'max-h-32 space-y-1 overflow-y-auto rounded-lg border border-border bg-muted/50 p-2 text-sm',
    fileRow: 'flex items-center gap-2 rounded-md px-1.5 py-1',
    fileIcon: 'shrink-0 text-text-muted',
    fileName: 'min-w-0 flex-1 truncate text-text-primary',
    fileSize: 'shrink-0 text-xs tabular-nums text-text-muted',

    // Step indicator — reference PublicTicketForm StepIndicator
    steps: 'mx-auto mb-6 flex w-full max-w-lg items-center justify-between gap-2',
    stepCol: 'flex flex-col items-center gap-1.5',
    // A completed step is a real button (you can click back to it); the current
    // and upcoming ones render as a plain div, so only the reachable one is a
    // tab stop.
    stepButton: 'rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    stepCircle:
        'flex h-9 w-9 items-center justify-center rounded-full text-xs font-semibold transition-colors',
    stepCircleActive: 'bg-primary-600 text-primary-foreground',
    stepCircleDone: 'bg-primary-600 text-primary-foreground hover:bg-primary-700',
    stepCircleIdle: 'bg-border text-text-muted',
    stepLabel: 'text-center text-[11px] font-medium leading-tight sm:text-xs',
    stepLabelActive: 'text-text-primary',
    stepLabelIdle: 'text-text-muted',
    stepConnector: 'mx-1 h-px min-w-[1rem] flex-1',
    stepConnectorDone: 'bg-primary-600',
    stepConnectorIdle: 'bg-border',
};

export const PRIORITY_RING = {
    low: 'ring-priority-low',
    medium: 'ring-priority-medium',
    high: 'ring-priority-high',
    urgent: 'ring-priority-urgent',
};

export default Style;
